import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalizationService } from './localization.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./localization.service";
var SiteConfigService = /** @class */ (function () {
    function SiteConfigService(http, baseUrl, localizationService) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.localizationService = localizationService;
        this.apiUrl = this.baseUrl + "api/siteConfig";
    }
    SiteConfigService.prototype.getSiteConfig = function () {
        var _this = this;
        return new Observable(function (subscriber) {
            _this.getSiteConfigCall(subscriber);
            _this.localizationService.addLangSubscriber(subscriber, function (obs) { return _this.getSiteConfigCall(obs); });
        });
    };
    SiteConfigService.prototype.getSiteConfigCall = function (subscriber) {
        var code = this.localizationService.getLocale();
        if (SiteConfigService.cache[code]) {
            subscriber.next(SiteConfigService.cache[code]);
            return;
        }
        this.http.get("" + this.apiUrl).subscribe(function (siteConfig) {
            SiteConfigService.cache[code] = siteConfig;
            subscriber.next(siteConfig);
        }, function (error) { return subscriber.error(error); });
    };
    SiteConfigService.cache = {};
    SiteConfigService.ngInjectableDef = i0.defineInjectable({ factory: function SiteConfigService_Factory() { return new SiteConfigService(i0.inject(i1.HttpClient), i0.inject("BASE_URL"), i0.inject(i2.LocalizationService)); }, token: SiteConfigService, providedIn: "root" });
    return SiteConfigService;
}());
export { SiteConfigService };
